import { Route, Switch, Redirect, useHistory } from 'react-router-dom';

// Only import and use "containers" for your route
import Wizard from './Wizard/Wizard';
import CreateLiveChatLoader from './CreateLiveChatLoader';
import LandingPage from './LandingPage';
import { IframeUtils } from 'feature-unboxing-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Paths = {
  HOME: '/',
  WIZARD: '/:step',
  FIRST_STEP: '/start',
  SECOND_STEP: '/customize',
  THIRD_STEP: '/style',
  CREATE: '/:portalId/create/:chatState?'
};
export const StepsMap = ['/start', '/customize', '/style'];
export const Routes = () => {
  const history = useHistory();
  const searchQuery = history.location.search;
  return /*#__PURE__*/_jsxs(Switch, {
    children: [IframeUtils.isInIframe() ? null : /*#__PURE__*/_jsx(Route, {
      path: Paths.HOME,
      exact: true,
      component: LandingPage
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.CREATE,
      component: CreateLiveChatLoader
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.WIZARD,
      component: Wizard
    }), /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: Paths.WIZARD.replace('/:step', Paths.FIRST_STEP),
        search: searchQuery
      }
    })]
  });
};